import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = window?.MAPBOX?.token ?? '';

export class Map extends AbstractComponent {
  init() {
    const {long, lat, zoom} = JSON.parse(this.el.dataset.map);
    const popup = this.el.dataset.popup;

    const map = new mapboxgl.Map({
      container: this.el,
      style: 'mapbox://styles/mapbox/light-v10',
      center: [long, lat],
      zoom: zoom,
    });

    map.on('wheel', event => {
      if (event.originalEvent.ctrlKey) {
        return;
      }

      if (event.originalEvent.metaKey) {
        return;
      }

      if (event.originalEvent.altKey) {
        return;
      }

      event.preventDefault();
    });

    const marker = document.createElement('div');

    new mapboxgl.Marker(marker)
      .setPopup(
        new mapboxgl.Popup({ offset: 25 }) // add popups
          .setHTML(popup)
      )
      .setLngLat([long, lat])
      .addTo(map);
  }
}

register('map', Map);
